import { useParams } from 'react-router-dom';
import { getRandomArray } from '../../../utils/getRandomArray/getRandomArray';
import { getRandomRangeArray } from '../../../utils/getRandomRangeArray/getRandomRangeArray';
import color from '../../../data/color/color.json';
import styles from '../Museum.module.scss';

export const Author = ({ upPage }) => {
  const { lang } = useParams();
  const { toptitle, title, text, items } = upPage.acf.author;
  const upRanColArr = getRandomArray(color.length, items.length);
  const upRanArr = getRandomRangeArray(2, 4, items.length);

  return (
    <section className={styles.author}>
      <div className="container">
        <div className={styles.author_body}>
          <h3 className={`${styles.author_toptitle} global-subtitle`}>{toptitle[lang]}</h3>
          <h2 className={`${styles.author_title} global-title`}>{title[lang]}</h2>
          <p className={`${styles.author_text} global-text`}>{text[lang]}</p>
          <div className={styles.author_row}>
            {items.map((el, idx) => {
              const { icon, author, period_life, text } = el;
              return (
                <div key={idx} className={styles.author_column}>
                  <div className={styles.author_column_body}>
                    <div className={styles.author_column_icon} style={{ background: color[upRanColArr[idx]] }}>
                      <div
                        style={{
                          animation: `${styles['bounce-center']} ${upRanArr[idx]}s ease-in-out infinite`,
                        }}
                      >
                        {icon}
                      </div>
                    </div>
                    <h3 className={styles.author_column_name}>{author[lang]}</h3>
                    <p className={styles.author_column_date}>
                      {`${period_life.birth_date ? period_life.birth_date : '0000'}-${period_life.death_date ? period_life.death_date : '0000'}`}
                    </p>
                    <p className={`${styles.author_column_text} global-text`}>{text[lang]}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
